"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/authorization/v1/authorization.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationServiceClient = exports.ServiceClient = exports.FindServicesResponse = exports.FindServicesRequest = exports.FindRoutesResponse = exports.FindRoutesRequest = exports.FindPermissionsResponse = exports.FindPermissionsRequest = exports.StringFilter = exports.PaginationRequest = exports.RemovePermissionFromCredentialResponse = exports.RemovePermissionFromCredentialRequest = exports.AddPermissionToCredentialResponse = exports.AddPermissionToCredentialRequest = exports.UpdateRouteResponse = exports.UpdateRouteRequest = exports.DeleteRouteResponse = exports.DeleteRouteRequest = exports.CreateRouteResponse = exports.CreateRouteRequest = exports.DeletePermissionResponse = exports.DeletePermissionRequest = exports.CreatePermissionResponse = exports.CreatePermissionRequest = exports.AuthorizeResponse = exports.AuthorizeRequest = exports.Route = exports.Service = exports.Permission = exports.stringFilter_TypeToJSON = exports.stringFilter_TypeFromJSON = exports.StringFilter_Type = void 0;
/* eslint-disable */
var health_1 = require("../../common/v1/health");
exports.StringFilter_Type = {
    TYPE_UNSPECIFIED: "TYPE_UNSPECIFIED",
    TYPE_EQUAL: "TYPE_EQUAL",
    TYPE_CONTAINS: "TYPE_CONTAINS",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function stringFilter_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return exports.StringFilter_Type.TYPE_UNSPECIFIED;
        case 1:
        case "TYPE_EQUAL":
            return exports.StringFilter_Type.TYPE_EQUAL;
        case 2:
        case "TYPE_CONTAINS":
            return exports.StringFilter_Type.TYPE_CONTAINS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.StringFilter_Type.UNRECOGNIZED;
    }
}
exports.stringFilter_TypeFromJSON = stringFilter_TypeFromJSON;
function stringFilter_TypeToJSON(object) {
    switch (object) {
        case exports.StringFilter_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case exports.StringFilter_Type.TYPE_EQUAL:
            return "TYPE_EQUAL";
        case exports.StringFilter_Type.TYPE_CONTAINS:
            return "TYPE_CONTAINS";
        case exports.StringFilter_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.stringFilter_TypeToJSON = stringFilter_TypeToJSON;
function createBasePermission() {
    return { id: "", name: "", description: "", created_at: "", updated_at: "" };
}
exports.Permission = {
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.updated_at !== "") {
            obj.updated_at = message.updated_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.Permission.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBasePermission();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : "";
        message.created_at = (_d = object.created_at) !== null && _d !== void 0 ? _d : "";
        message.updated_at = (_e = object.updated_at) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseService() {
    return { id: "", name: "", created_at: "", updated_at: "" };
}
exports.Service = {
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.updated_at !== "") {
            obj.updated_at = message.updated_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.Service.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseService();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.created_at = (_c = object.created_at) !== null && _c !== void 0 ? _c : "";
        message.updated_at = (_d = object.updated_at) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseRoute() {
    return {
        id: "",
        path_matcher: "",
        verb_matcher: "",
        host_matcher: "",
        service: undefined,
        permissions: [],
        created_at: "",
        updated_at: "",
    };
}
exports.Route = {
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            path_matcher: isSet(object.path_matcher) ? globalThis.String(object.path_matcher) : "",
            verb_matcher: isSet(object.verb_matcher) ? globalThis.String(object.verb_matcher) : "",
            host_matcher: isSet(object.host_matcher) ? globalThis.String(object.host_matcher) : "",
            service: isSet(object.service) ? exports.Service.fromJSON(object.service) : undefined,
            permissions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.permissions)
                ? object.permissions.map(function (e) { return exports.Permission.fromJSON(e); })
                : [],
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : "",
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.path_matcher !== "") {
            obj.path_matcher = message.path_matcher;
        }
        if (message.verb_matcher !== "") {
            obj.verb_matcher = message.verb_matcher;
        }
        if (message.host_matcher !== "") {
            obj.host_matcher = message.host_matcher;
        }
        if (message.service !== undefined) {
            obj.service = exports.Service.toJSON(message.service);
        }
        if ((_a = message.permissions) === null || _a === void 0 ? void 0 : _a.length) {
            obj.permissions = message.permissions.map(function (e) { return exports.Permission.toJSON(e); });
        }
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.updated_at !== "") {
            obj.updated_at = message.updated_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.Route.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        var message = createBaseRoute();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.path_matcher = (_b = object.path_matcher) !== null && _b !== void 0 ? _b : "";
        message.verb_matcher = (_c = object.verb_matcher) !== null && _c !== void 0 ? _c : "";
        message.host_matcher = (_d = object.host_matcher) !== null && _d !== void 0 ? _d : "";
        message.service = (object.service !== undefined && object.service !== null)
            ? exports.Service.fromPartial(object.service)
            : undefined;
        message.permissions = ((_e = object.permissions) === null || _e === void 0 ? void 0 : _e.map(function (e) { return exports.Permission.fromPartial(e); })) || [];
        message.created_at = (_f = object.created_at) !== null && _f !== void 0 ? _f : "";
        message.updated_at = (_g = object.updated_at) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
function createBaseAuthorizeRequest() {
    return { url: "", token: "" };
}
exports.AuthorizeRequest = {
    fromJSON: function (object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            token: isSet(object.token) ? globalThis.String(object.token) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.token !== "") {
            obj.token = message.token;
        }
        return obj;
    },
    create: function (base) {
        return exports.AuthorizeRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAuthorizeRequest();
        message.url = (_a = object.url) !== null && _a !== void 0 ? _a : "";
        message.token = (_b = object.token) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseAuthorizeResponse() {
    return { permissions_token: "" };
}
exports.AuthorizeResponse = {
    fromJSON: function (object) {
        return { permissions_token: isSet(object.permissions_token) ? globalThis.String(object.permissions_token) : "" };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.permissions_token !== "") {
            obj.permissions_token = message.permissions_token;
        }
        return obj;
    },
    create: function (base) {
        return exports.AuthorizeResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseAuthorizeResponse();
        message.permissions_token = (_a = object.permissions_token) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseCreatePermissionRequest() {
    return { name: "", description: "" };
}
exports.CreatePermissionRequest = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        return obj;
    },
    create: function (base) {
        return exports.CreatePermissionRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseCreatePermissionRequest();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseCreatePermissionResponse() {
    return { permission: undefined };
}
exports.CreatePermissionResponse = {
    fromJSON: function (object) {
        return { permission: isSet(object.permission) ? exports.Permission.fromJSON(object.permission) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.permission !== undefined) {
            obj.permission = exports.Permission.toJSON(message.permission);
        }
        return obj;
    },
    create: function (base) {
        return exports.CreatePermissionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseCreatePermissionResponse();
        message.permission = (object.permission !== undefined && object.permission !== null)
            ? exports.Permission.fromPartial(object.permission)
            : undefined;
        return message;
    },
};
function createBaseDeletePermissionRequest() {
    return { name: "" };
}
exports.DeletePermissionRequest = {
    fromJSON: function (object) {
        return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        return obj;
    },
    create: function (base) {
        return exports.DeletePermissionRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseDeletePermissionRequest();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseDeletePermissionResponse() {
    return {};
}
exports.DeletePermissionResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.DeletePermissionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseDeletePermissionResponse();
        return message;
    },
};
function createBaseCreateRouteRequest() {
    return { path_matcher: "", verb_matcher: "", host_matcher: "", service_name: "", permission_names: [] };
}
exports.CreateRouteRequest = {
    fromJSON: function (object) {
        return {
            path_matcher: isSet(object.path_matcher) ? globalThis.String(object.path_matcher) : "",
            verb_matcher: isSet(object.verb_matcher) ? globalThis.String(object.verb_matcher) : "",
            host_matcher: isSet(object.host_matcher) ? globalThis.String(object.host_matcher) : "",
            service_name: isSet(object.service_name) ? globalThis.String(object.service_name) : "",
            permission_names: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.permission_names)
                ? object.permission_names.map(function (e) { return globalThis.String(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.path_matcher !== "") {
            obj.path_matcher = message.path_matcher;
        }
        if (message.verb_matcher !== "") {
            obj.verb_matcher = message.verb_matcher;
        }
        if (message.host_matcher !== "") {
            obj.host_matcher = message.host_matcher;
        }
        if (message.service_name !== "") {
            obj.service_name = message.service_name;
        }
        if ((_a = message.permission_names) === null || _a === void 0 ? void 0 : _a.length) {
            obj.permission_names = message.permission_names;
        }
        return obj;
    },
    create: function (base) {
        return exports.CreateRouteRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBaseCreateRouteRequest();
        message.path_matcher = (_a = object.path_matcher) !== null && _a !== void 0 ? _a : "";
        message.verb_matcher = (_b = object.verb_matcher) !== null && _b !== void 0 ? _b : "";
        message.host_matcher = (_c = object.host_matcher) !== null && _c !== void 0 ? _c : "";
        message.service_name = (_d = object.service_name) !== null && _d !== void 0 ? _d : "";
        message.permission_names = ((_e = object.permission_names) === null || _e === void 0 ? void 0 : _e.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseCreateRouteResponse() {
    return { route: undefined };
}
exports.CreateRouteResponse = {
    fromJSON: function (object) {
        return { route: isSet(object.route) ? exports.Route.fromJSON(object.route) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.route !== undefined) {
            obj.route = exports.Route.toJSON(message.route);
        }
        return obj;
    },
    create: function (base) {
        return exports.CreateRouteResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseCreateRouteResponse();
        message.route = (object.route !== undefined && object.route !== null) ? exports.Route.fromPartial(object.route) : undefined;
        return message;
    },
};
function createBaseDeleteRouteRequest() {
    return { id: "" };
}
exports.DeleteRouteRequest = {
    fromJSON: function (object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create: function (base) {
        return exports.DeleteRouteRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseDeleteRouteRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseDeleteRouteResponse() {
    return {};
}
exports.DeleteRouteResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.DeleteRouteResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseDeleteRouteResponse();
        return message;
    },
};
function createBaseUpdateRouteRequest() {
    return { route: undefined };
}
exports.UpdateRouteRequest = {
    fromJSON: function (object) {
        return { route: isSet(object.route) ? exports.Route.fromJSON(object.route) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.route !== undefined) {
            obj.route = exports.Route.toJSON(message.route);
        }
        return obj;
    },
    create: function (base) {
        return exports.UpdateRouteRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseUpdateRouteRequest();
        message.route = (object.route !== undefined && object.route !== null) ? exports.Route.fromPartial(object.route) : undefined;
        return message;
    },
};
function createBaseUpdateRouteResponse() {
    return { route: undefined };
}
exports.UpdateRouteResponse = {
    fromJSON: function (object) {
        return { route: isSet(object.route) ? exports.Route.fromJSON(object.route) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.route !== undefined) {
            obj.route = exports.Route.toJSON(message.route);
        }
        return obj;
    },
    create: function (base) {
        return exports.UpdateRouteResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseUpdateRouteResponse();
        message.route = (object.route !== undefined && object.route !== null) ? exports.Route.fromPartial(object.route) : undefined;
        return message;
    },
};
function createBaseAddPermissionToCredentialRequest() {
    return { permission_name: "", credential_id: "" };
}
exports.AddPermissionToCredentialRequest = {
    fromJSON: function (object) {
        return {
            permission_name: isSet(object.permission_name) ? globalThis.String(object.permission_name) : "",
            credential_id: isSet(object.credential_id) ? globalThis.String(object.credential_id) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.permission_name !== "") {
            obj.permission_name = message.permission_name;
        }
        if (message.credential_id !== "") {
            obj.credential_id = message.credential_id;
        }
        return obj;
    },
    create: function (base) {
        return exports.AddPermissionToCredentialRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseAddPermissionToCredentialRequest();
        message.permission_name = (_a = object.permission_name) !== null && _a !== void 0 ? _a : "";
        message.credential_id = (_b = object.credential_id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseAddPermissionToCredentialResponse() {
    return {};
}
exports.AddPermissionToCredentialResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.AddPermissionToCredentialResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseAddPermissionToCredentialResponse();
        return message;
    },
};
function createBaseRemovePermissionFromCredentialRequest() {
    return { permission_name: "", credential_id: "" };
}
exports.RemovePermissionFromCredentialRequest = {
    fromJSON: function (object) {
        return {
            permission_name: isSet(object.permission_name) ? globalThis.String(object.permission_name) : "",
            credential_id: isSet(object.credential_id) ? globalThis.String(object.credential_id) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.permission_name !== "") {
            obj.permission_name = message.permission_name;
        }
        if (message.credential_id !== "") {
            obj.credential_id = message.credential_id;
        }
        return obj;
    },
    create: function (base) {
        return exports.RemovePermissionFromCredentialRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseRemovePermissionFromCredentialRequest();
        message.permission_name = (_a = object.permission_name) !== null && _a !== void 0 ? _a : "";
        message.credential_id = (_b = object.credential_id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseRemovePermissionFromCredentialResponse() {
    return {};
}
exports.RemovePermissionFromCredentialResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.RemovePermissionFromCredentialResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseRemovePermissionFromCredentialResponse();
        return message;
    },
};
function createBasePaginationRequest() {
    return { page: undefined, items_per_page: undefined };
}
exports.PaginationRequest = {
    fromJSON: function (object) {
        return {
            page: isSet(object.page) ? globalThis.Number(object.page) : undefined,
            items_per_page: isSet(object.items_per_page) ? globalThis.Number(object.items_per_page) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.page !== undefined) {
            obj.page = Math.round(message.page);
        }
        if (message.items_per_page !== undefined) {
            obj.items_per_page = Math.round(message.items_per_page);
        }
        return obj;
    },
    create: function (base) {
        return exports.PaginationRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBasePaginationRequest();
        message.page = (_a = object.page) !== null && _a !== void 0 ? _a : undefined;
        message.items_per_page = (_b = object.items_per_page) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseStringFilter() {
    return { value: "", filter_type: exports.StringFilter_Type.TYPE_UNSPECIFIED };
}
exports.StringFilter = {
    fromJSON: function (object) {
        return {
            value: isSet(object.value) ? globalThis.String(object.value) : "",
            filter_type: isSet(object.filter_type)
                ? stringFilter_TypeFromJSON(object.filter_type)
                : exports.StringFilter_Type.TYPE_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.value !== "") {
            obj.value = message.value;
        }
        if (message.filter_type !== exports.StringFilter_Type.TYPE_UNSPECIFIED) {
            obj.filter_type = stringFilter_TypeToJSON(message.filter_type);
        }
        return obj;
    },
    create: function (base) {
        return exports.StringFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseStringFilter();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : "";
        message.filter_type = (_b = object.filter_type) !== null && _b !== void 0 ? _b : exports.StringFilter_Type.TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseFindPermissionsRequest() {
    return { pagination: undefined, permission_name: undefined };
}
exports.FindPermissionsRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? exports.PaginationRequest.fromJSON(object.pagination) : undefined,
            permission_name: isSet(object.permission_name) ? exports.StringFilter.fromJSON(object.permission_name) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = exports.PaginationRequest.toJSON(message.pagination);
        }
        if (message.permission_name !== undefined) {
            obj.permission_name = exports.StringFilter.toJSON(message.permission_name);
        }
        return obj;
    },
    create: function (base) {
        return exports.FindPermissionsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseFindPermissionsRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? exports.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.permission_name = (object.permission_name !== undefined && object.permission_name !== null)
            ? exports.StringFilter.fromPartial(object.permission_name)
            : undefined;
        return message;
    },
};
function createBaseFindPermissionsResponse() {
    return { permissions: [], total_pages: 0, total_items: 0 };
}
exports.FindPermissionsResponse = {
    fromJSON: function (object) {
        return {
            permissions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.permissions)
                ? object.permissions.map(function (e) { return exports.Permission.fromJSON(e); })
                : [],
            total_pages: isSet(object.total_pages) ? globalThis.Number(object.total_pages) : 0,
            total_items: isSet(object.total_items) ? globalThis.Number(object.total_items) : 0,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.permissions) === null || _a === void 0 ? void 0 : _a.length) {
            obj.permissions = message.permissions.map(function (e) { return exports.Permission.toJSON(e); });
        }
        if (message.total_pages !== 0) {
            obj.total_pages = Math.round(message.total_pages);
        }
        if (message.total_items !== 0) {
            obj.total_items = Math.round(message.total_items);
        }
        return obj;
    },
    create: function (base) {
        return exports.FindPermissionsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseFindPermissionsResponse();
        message.permissions = ((_a = object.permissions) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.Permission.fromPartial(e); })) || [];
        message.total_pages = (_b = object.total_pages) !== null && _b !== void 0 ? _b : 0;
        message.total_items = (_c = object.total_items) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseFindRoutesRequest() {
    return { pagination: undefined, service_name: undefined, permission_name: undefined, path_matcher: undefined };
}
exports.FindRoutesRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? exports.PaginationRequest.fromJSON(object.pagination) : undefined,
            service_name: isSet(object.service_name) ? exports.StringFilter.fromJSON(object.service_name) : undefined,
            permission_name: isSet(object.permission_name) ? exports.StringFilter.fromJSON(object.permission_name) : undefined,
            path_matcher: isSet(object.path_matcher) ? exports.StringFilter.fromJSON(object.path_matcher) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = exports.PaginationRequest.toJSON(message.pagination);
        }
        if (message.service_name !== undefined) {
            obj.service_name = exports.StringFilter.toJSON(message.service_name);
        }
        if (message.permission_name !== undefined) {
            obj.permission_name = exports.StringFilter.toJSON(message.permission_name);
        }
        if (message.path_matcher !== undefined) {
            obj.path_matcher = exports.StringFilter.toJSON(message.path_matcher);
        }
        return obj;
    },
    create: function (base) {
        return exports.FindRoutesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseFindRoutesRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? exports.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.service_name = (object.service_name !== undefined && object.service_name !== null)
            ? exports.StringFilter.fromPartial(object.service_name)
            : undefined;
        message.permission_name = (object.permission_name !== undefined && object.permission_name !== null)
            ? exports.StringFilter.fromPartial(object.permission_name)
            : undefined;
        message.path_matcher = (object.path_matcher !== undefined && object.path_matcher !== null)
            ? exports.StringFilter.fromPartial(object.path_matcher)
            : undefined;
        return message;
    },
};
function createBaseFindRoutesResponse() {
    return { routes: [], total_pages: 0, total_items: 0 };
}
exports.FindRoutesResponse = {
    fromJSON: function (object) {
        return {
            routes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.routes) ? object.routes.map(function (e) { return exports.Route.fromJSON(e); }) : [],
            total_pages: isSet(object.total_pages) ? globalThis.Number(object.total_pages) : 0,
            total_items: isSet(object.total_items) ? globalThis.Number(object.total_items) : 0,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.routes) === null || _a === void 0 ? void 0 : _a.length) {
            obj.routes = message.routes.map(function (e) { return exports.Route.toJSON(e); });
        }
        if (message.total_pages !== 0) {
            obj.total_pages = Math.round(message.total_pages);
        }
        if (message.total_items !== 0) {
            obj.total_items = Math.round(message.total_items);
        }
        return obj;
    },
    create: function (base) {
        return exports.FindRoutesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseFindRoutesResponse();
        message.routes = ((_a = object.routes) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.Route.fromPartial(e); })) || [];
        message.total_pages = (_b = object.total_pages) !== null && _b !== void 0 ? _b : 0;
        message.total_items = (_c = object.total_items) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseFindServicesRequest() {
    return { pagination: undefined, service_name: undefined };
}
exports.FindServicesRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? exports.PaginationRequest.fromJSON(object.pagination) : undefined,
            service_name: isSet(object.service_name) ? exports.StringFilter.fromJSON(object.service_name) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = exports.PaginationRequest.toJSON(message.pagination);
        }
        if (message.service_name !== undefined) {
            obj.service_name = exports.StringFilter.toJSON(message.service_name);
        }
        return obj;
    },
    create: function (base) {
        return exports.FindServicesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseFindServicesRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? exports.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.service_name = (object.service_name !== undefined && object.service_name !== null)
            ? exports.StringFilter.fromPartial(object.service_name)
            : undefined;
        return message;
    },
};
function createBaseFindServicesResponse() {
    return { services: [], total_pages: 0, total_items: 0 };
}
exports.FindServicesResponse = {
    fromJSON: function (object) {
        return {
            services: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.services) ? object.services.map(function (e) { return exports.Service.fromJSON(e); }) : [],
            total_pages: isSet(object.total_pages) ? globalThis.Number(object.total_pages) : 0,
            total_items: isSet(object.total_items) ? globalThis.Number(object.total_items) : 0,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.services) === null || _a === void 0 ? void 0 : _a.length) {
            obj.services = message.services.map(function (e) { return exports.Service.toJSON(e); });
        }
        if (message.total_pages !== 0) {
            obj.total_pages = Math.round(message.total_pages);
        }
        if (message.total_items !== 0) {
            obj.total_items = Math.round(message.total_items);
        }
        return obj;
    },
    create: function (base) {
        return exports.FindServicesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseFindServicesResponse();
        message.services = ((_a = object.services) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.Service.fromPartial(e); })) || [];
        message.total_pages = (_b = object.total_pages) !== null && _b !== void 0 ? _b : 0;
        message.total_items = (_c = object.total_items) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var ServiceClient = /** @class */ (function () {
    function ServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    return ServiceClient;
}());
exports.ServiceClient = ServiceClient;
var AuthorizationServiceClient = /** @class */ (function () {
    function AuthorizationServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    AuthorizationServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.Authorize = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.AuthorizeRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/Authorize";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.AuthorizeResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.CreatePermission = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.CreatePermissionRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/CreatePermission";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.CreatePermissionResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.DeletePermission = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.DeletePermissionRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/DeletePermission";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.DeletePermissionResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.FindPermissions = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FindPermissionsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/FindPermissions";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FindPermissionsResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.CreateRoute = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.CreateRouteRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/CreateRoute";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.CreateRouteResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.DeleteRoute = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.DeleteRouteRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/DeleteRoute";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.DeleteRouteResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.UpdateRoute = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.UpdateRouteRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/UpdateRoute";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.UpdateRouteResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.FindRoutes = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FindRoutesRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/FindRoutes";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FindRoutesResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.AddPermissionToCredential = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.AddPermissionToCredentialRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/AddPermissionToCredential";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.AddPermissionToCredentialResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.RemovePermissionFromCredential = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.RemovePermissionFromCredentialRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/RemovePermissionFromCredential";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.RemovePermissionFromCredentialResponse.fromJSON, options)];
            });
        });
    };
    AuthorizationServiceClient.prototype.FindServices = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FindServicesRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.authorization.v1.AuthorizationService/FindServices";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FindServicesResponse.fromJSON, options)];
            });
        });
    };
    return AuthorizationServiceClient;
}());
exports.AuthorizationServiceClient = AuthorizationServiceClient;
//# sourceMappingURL=authorization.js.map